import { render, staticRenderFns, recyclableRender, components } from "./detail.vue?vue&type=template&id=2c4150ef&scoped=true&"
var renderjs
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=2c4150ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../HBuilderX.3.8.4.20230531/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4150ef",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/tabBar/current/detail.vue"
export default component.exports